import {gql} from '@apollo/client';

export const workspaceQueries = {
    GET_WORKSPACES: gql`
        #Getting all Workspaces
        query GetWorkspaces {
            workspaces {
                id
                title
                slug
                selectedBoardSlug
            }
        }
    `,

    GET_WORKSPACE_BY_ID: gql`
        #Getting Workspace By ID
        query GetWorkspaceByID($id: UUID!) {
            workspaceById(id: $id) {
                id
                name
                description
                workspaceType
                privacyType
                color
                image
                boards {
                    id
                    boardType
                    title
                    description
                    boardPrivacy
                    itemFields
                    publicForm
                }
            }
        }
    `,
    GET_USERS_BY_WORKSPACE_SLUG: gql`
        #Getting Users By Workspace ID
        query GetUsersByWorkspaceSlug($workspaceSlug: String!) {
            usersByWorkspaceSlug(workspaceSlug: $workspaceSlug) {
                nodes {
                    id
                    email
                    firstName
                    status
                    lastName
                    userName
                }
            }
        }
    `,
    GET_USERS_OF_ALL_WORKSPACES_BY_USER_ID: gql`
        #Getting Users Of All Workspaces By User ID
        query GetUsersOfAllWorkspacesByUserId($tenantId: UUID!, $where: UserRelationListingResponseModelFilterInput) {
            usersOfAllWorkspacesByUserSlug(tenantId: $tenantId, where: $where) {
                id
                email
                firstName
                status
                lastName
                userName
            }
        }
    `,
};
